export const INDEX_LOADING = "INDEX_LOADING";
export const INDEX_SUCCESS = "INDEX_SUCCESS";
export const INDEX_FAIL = "INDEX_FAIL";

export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const USER_DATA_LOADING = "USER_DATA_LOADING";
export const USER_DATA_FAILED = "USER_DATA_FAILED";
export const USER_DATA_LOADED = "USER_DATA_LOADED";